<template>
    <UnitId />
</template>

<script>
// import UnitCard from '@/components/cards/unitCard'
// import { mapGetters, mapMutations, mapActions } from 'vuex'
// import UnitTree from '@/components/UnitTree.vue'
// import UnitDropdown from '@/components/UnitDropdown'

import UnitId from './_unitId'

export default {
    components: {
        UnitId,
    },
}
// export default {
//     components: {
//         UnitTree,
//         UnitCard,
//         UnitDropdown,
//     },

//     created() {
//         this.getUnits()
//     },

//     watch: {
//         '$route.query.unitId'(oldVal, newVal) {
//             // // console.log('val', oldVal, newVal)
//             // this.selectedUnitId = newVal
//             this.$nextTick()
//         },
//     },

//     methods: {
//         onUnitSelected(key) {
//             // console.log('onUnitSelected', key)

//             if (typeof key === 'object') {
//                 key = key.id
//             }
//             this.$router.push('./directory/' + key)
//         },

//         ...mapActions({
//             getUnits: 'companies/getUnits',
//         }),
//     },

//     computed: {
//         unitId() {
//             if (this.units.length == 0) {
//                 return ''
//             }

//             if (this.$route.params.unitId) {
//                 return this.$route.params.unitId
//             }

//             return this.rootUnit.id
//         },

//         ...mapGetters({
//             rootUnit: 'companies/rootUnit',
//             unitTree: 'companies/unitTree',
//             units: 'companies/units',
//             unitRoot: 'companies/rootUnit',
//         }),
//     },
// }
</script>
